// extracted by mini-css-extract-plugin
export default {"viewBox":"SettingBoxItem_viewBox__FGshI","iconBox":"SettingBoxItem_iconBox__l6PFS","title":"SettingBoxItem_title__UsXzw","subTitle":"SettingBoxItem_subTitle__f2ZOm"};